import { Theme, css } from '@emotion/react';

export const layout = ({ borderRadius, spacing }: Theme) => css`
  --thumbnail-size: 72px;

  align-items: center;
  display: grid;
  grid-template-columns: var(--thumbnail-size) minmax(0, 1fr);
  gap: ${spacing(2)}px;

  & > img {
    aspect-ratio: 1/1;
    border-radius: ${borderRadius[100]};
    object-fit: cover;
    width: 100%;
  }
`;
